// extracted by mini-css-extract-plugin
export default {"tableContainer":"ManifestsTable_tableContainer__VmlCc","row":"ManifestsTable_row__TdzeL"};